import { render, staticRenderFns } from "./CartSide.vue?vue&type=template&id=62c535a0&"
import script from "./CartSide.vue?vue&type=script&lang=js&"
export * from "./CartSide.vue?vue&type=script&lang=js&"
import style0 from "./CartSide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports